import React, { Component } from 'react';

import AccoladeIcons from './AccoladeIcons';
import Constants from '../Constants';
import Utils from '../Utils';

import '../styles/ScoreboardRow.css';

class ScoreboardRow extends Component {
  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.score.name);
    }
  }

  render() {
    // The signed-in player's row is coloured as theirs wherever it falls, on
    // the board or under it -- so it is picked out of the striping rather than
    // taking a turn in it.
    const shade = this.props.own ? "own" : (this.props.index % 2 === 0 ? "even" : "odd");
    const multiDay = !!this.props.rangeDayCount;

    // A week lists its seven days. A season is six weeks, so it lists what each
    // day of the week contributed instead -- seven numbers that add up to the
    // total either way, and both Monday first, so the two lay out alike: in
    // columns under the weekday each belongs to, since three digits apiece is
    // too long for one line on a narrow board.
    let weekdayScores = null;
    let scoreHistoryTitle = null;
    if (this.props.rangeStartDate) {
      weekdayScores = Constants.DAYS.map((_, i) => (
        this.props.score.history[Utils.addDays(this.props.rangeStartDate, i)]
      ));
    } else if (multiDay && this.props.score.countedByDayOfWeek) {
      weekdayScores = this.props.score.countedByDayOfWeek;
      // A week's are plainly its days; a season's need the rule saying. "Five"
      // is spelled out rather than read off the constant; Scoreboard.test.js
      // holds the two together.
      scoreHistoryTitle = "The sum of the best five scores for each day.";
    }

    // The hover swap is CSS, so a row only claims it if it has something to
    // swap in: a standing with no per-day scores behind it keeps its total.
    let classes = "scoreboard-row scoreboard-row-" + shade;
    classes += this.props.onClick ? " scoreboard-row-clickable" : "";
    classes += weekdayScores ? " scoreboard-row-range" : "";
    classes += this.props.rangeStartDate ? " scoreboard-row-week" : "";

    const scoreHistoryElement = (
      <div className="scoreboard-row-score-history" title={scoreHistoryTitle}>
        { weekdayScores && weekdayScores.map((score, i) => (
          // Constants.DAYS is Sunday first.
          <div className="scoreboard-row-weekday" key={i}>
            <div className="scoreboard-row-weekday-name">{Constants.DAYS[(i + 1) % 7].slice(0, 3)}</div>
            <div className="scoreboard-row-weekday-score">{score ? score : 0}</div>
          </div>
        ))}
      </div>
    );

    const scoreElement = (
      <>
        <div className="scoreboard-row-rank">
          {this.props.score.rank}
        </div>
        <div className="scoreboard-row-identity">
          <AccoladeIcons
            name={this.props.score.name}
            yesterdayRank={this.props.yesterdayRank}
            lastWeekRank={this.props.lastWeekRank}
            lastSeasonRank={this.props.lastSeasonRank}
            seasonsStarted={this.props.seasonsStarted}
          />
          <div className="scoreboard-row-name">
            {this.props.score.name}
          </div>
        </div>
        <div className="scoreboard-row-score" title={multiDay ? `${this.props.score.games} games` : null}>
          { this.props.score.score }
        </div>
      </>
    );

    return (
      <div
        className={classes}
        onClick={this.handleClick}
      >
        { scoreElement }
        { weekdayScores && scoreHistoryElement }
      </div>
    );
  }
}

export default ScoreboardRow;
